import { NavLink } from "react-router-dom";
import BtnDarkMode from "../buttonDarkMode/BtnDarkMode";
import "./style.css";
const Navbar = () => {
  const activeLink = "nav-list__link nav-list__link--active";
  const normalLink = "nav-list__link";

  return (
    <nav className="nav">
      <div className="container">
        <div className="nav-row">
          <NavLink to={"/portfolio"} className="logo">
            portfolio
          </NavLink>

          <BtnDarkMode />

          <ul className="nav-list">
            <li className="nav-list__item">
              <NavLink
                to={"/portfolio"}
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
              >
                Home
              </NavLink>
            </li>
            <li className="nav-list__item">
              <NavLink
                to={"/projects"}
                // className="nav-list__link"
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
              >
                Projects
              </NavLink>
            </li>
            <li className="nav-list__item">
              <NavLink
                to={"/activity"}
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
              >
                Activity
              </NavLink>
            </li>
            <li className="nav-list__item">
              <NavLink
                to={"/contacts"}
                //  className="nav-list__link"
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
              >
                Contacts
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
